export default __webpack_public_path__ + "static/media/facebook.460fd188.svg";